import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { LotClubbingDto } from "./dto/lot-clubbing.dto";
import { CommonResponse } from "@gtpl/shared-models/masters";
import appSettings from "apps/services/config";
import { GenericTransactionManager } from "apps/services/backend/typeorm-transactions/generic-transaction-manager";
import { getManager } from "typeorm";
import { MatserClubbedLots } from "./lot-clubbing.entity";
import { ChildClubbedLots } from "./lot-clubbing-items.entity";
import { OperationTypeEnum } from "@gtpl/shared-models/common-models";

@Injectable()
export class LotClubbingService {
    constructor(
        // @InjectRepository(ProductConversion)
        // private productConversionRepository: Repository<ProductConversion>,
        // private productConversionAdapter: ProductConversionAdapter,
        // private saleService: SaleOrderService,
    ) { }
    async createLotClubbing(req:LotClubbingDto):Promise<CommonResponse>{
        const manager = getManager()
        const prodInvData = `select prod_inv_id as prodInvId from ${appSettings.production_db}.production_inventory where lot_number = '${req.mainlotNo}' and sale_order_id = ${req.saleOrderId} and sale_order_item_id = ${req.soItemId} and plant_id = ${req.plantId} and sub_plant_id = ${req.subPlantId} and operation = '${req.operation}'`
        console.log(prodInvData,'prodInvDatajjj')
        const res = await manager.query(prodInvData)
        if(prodInvData){
            const clubLotsModel = new MatserClubbedLots() 
            clubLotsModel.mainLot = req.mainlotNo
            clubLotsModel.operation = req.operation
            clubLotsModel.saleOrderId = req.saleOrderId
            clubLotsModel.soItemId = req.soItemId
            clubLotsModel.plantId = req.plantId
            clubLotsModel.subPlantId = req.subPlantId
            clubLotsModel.purpose = req.purpose
            clubLotsModel.remarks = req.remarks
            clubLotsModel.createdUser = req.createdUser
            clubLotsModel.productionInventoryId = res[0].prodInvId
            const childLotInfo = []
            let totQty = 0
            let totBoxes = 0
            for(const item of req.subLotInfo){
                const itemObj = new ChildClubbedLots()
                itemObj.lotNumber = item.lotNumber
                itemObj.subLotNumber = item.sublotNumber
                itemObj.quantity = item.quantity
                itemObj.createdUser = req.createdUser
                itemObj.opBoxes = item.opBoxes
                childLotInfo.push(itemObj)
                totQty = Number(totQty)+Number(item.quantity)
                totBoxes = Number(totBoxes)+Number(item.opBoxes)
                console.log(totBoxes,'totBoxesssssssssssssssssssssssssss')
            }
            clubLotsModel.childLotInfo = childLotInfo
            const saveLog = await manager.save(clubLotsModel);
            if(saveLog){
                const tobeupdateval = res[0].prodInvId
                let prodInvUpdate
                if(clubLotsModel.operation == OperationTypeEnum.GRN){
                    prodInvUpdate = await manager.update('production_inventory',{productionInventoryId:tobeupdateval},{physicalQuantity:()=>`physical_quantity+${totQty}`,opBoxes:()=>`op_boxes+${totBoxes}`,boxes:()=>`boxes+${totBoxes}`})
                }else{
                    prodInvUpdate = await manager.update('production_inventory',{productionInventoryId:tobeupdateval},{physicalQuantity:()=>`physical_quantity+${totQty}`,opBoxes:()=>`op_boxes+${totBoxes}`})
                }
                // const prodInvUpdateQry = `update ${appSettings.production_db}.production_inventory set physical_quantity = physical_quantity+${totQty},op_boxes = op_boxes+${totBoxes} where prod_inv_id = ${res[0].prodInvId}`
                // const prodInvUpdate = await manager.query(prodInvUpdateQry)
                if(prodInvUpdate.affected){
                    let updateFlag = true
                    for(const record of req.subLotInfo){
                        const childLotInvUpdate = await manager.update('production_inventory',{subLotNumber:`${record.sublotNumber}`,operation:req.operation,plantId:`${req.plantId}`,subPlantId :`${req.subPlantId}`},{physicalQuantity:0})
                        // const childLotInvUpdateQry = `update ${appSettings.production_db}.production_inventory set physical_quantity = 0 where sub_lot_number = ${record.sublotNumber} and plant_id = ${req.plantId} and sub_plant_id = ${req.subPlantId}`
                        // const childLotInvUpdate = await manager.query(childLotInvUpdateQry)
                        if(!(childLotInvUpdate.affected)){
                            updateFlag = false
                            break
                        }
                    }
                    if(updateFlag){
                        return new CommonResponse(true,1111,'Lot clubbed successfully')
                    }else{
                        // await manager.release()
                        return new CommonResponse(false,1111,'something went wrong in lo saving')
                    }
                }else{
                    // await manager.release()
                    return new CommonResponse(false,1111,'something went wrong in Inventory Update')
                }
            }else{
                // await manager.release()
                return new CommonResponse(false,1111,'something went wrong in lo saving')
            }
        }else{
            // await manager.release()
            return new CommonResponse(false,1111,'No lot Found')
        }
    }
}